<template>
    <b-modal
        v-bind="$attrs"
        v-on="$listeners"
        :scrollable="scrollable"
        @shown="onModalShown"
        @hidden="onModalHidden"
        :visible="value"
        @change="(val) => $emit('input', val)"
        :no-fade="true"
        content-class="custom-modal-content"
        header-class="custom-modal-header"
        footer-class="custom-modal-footer"
        :body-class="bodyClasses"
        dialog-class="custom-modal-dialog"
    >
        <template #modal-title v-if="!title">
            <slot name="modal-title"> </slot>
        </template>
        <slot></slot>
        <template #modal-footer="{ cancel, ok }" v-if="modalFooterSlot">
            <slot name="modal-footer" :cancel="cancel" :ok="ok"></slot>
        </template>
    </b-modal>
</template>

<script>
    export default {
        props: {
            scrollable: {
                type: Boolean,
                default: true,
            },
            value: {
                type: Boolean,
                default: false,
            },
            withBackground: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.$event.$on('shown', this.onModalShown);
            this.$event.$on('hidden', this.onModalHidden);
        },
        beforeUnmount() {
            this.$event.$off('shown', this.onModalShown);
            this.$event.$off('hidden', this.onModalHidden);
        },
        computed: {
            title() {
                return this.$attrs.title || '';
            },
            modalFooterSlot() {
                return !!this.$slots['modal-footer'];
            },
            bodyClasses() {
                return this.withBackground ? 'custom-modal-body custom-modal-body-with-bg' : 'custom-modal-body';
            },
        },
        methods: {
            onModalShown(event) {
                this.$listeners['shown'] && this.$listeners['shown'](event);
                this.toggleIntercomVisibility(true);
                document.getElementById('vue-app-modal-container').appendChild(event.target.parentNode);
                this.focusBody();
            },
            onModalHidden(event) {
                this.$listeners['hidden'] && this.$listeners['hidden'](event);
                this.toggleIntercomVisibility(false);
            },
            focusBody() {
                const el = document.querySelector('.modal-body');
                el.setAttribute('tabindex', 0);
                el.focus();
            },
            toggleIntercomVisibility(value) {
                const elem =
                    document.querySelector('.intercom-lightweight-app') ||
                    document.querySelector('.intercom-launcher-frame');
                if (elem) {
                    elem.style.zIndex = value ? 1 : 99999;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    :deep(.modal-body.custom-modal-body) {
        padding: 24px 25px !important;

        &:focus,
        &:focus-visible {
            outline: none !important;
        }
    }
</style>

<style lang="scss">
    :root {
        --modal-border-radius: 16px;
        --modal-padding-x: 24px;
        --modal-padding-y: 20px;
        --modal-body-padding-x: 28px;
        --modal-body-padding-y: 24px;
        --modal-footer-bg: #f8f9fa;
        --button-secondary-bg: #f5f5f5;
        --button-secondary-hover: #ebebeb;
    }
    $brand-color: #0d47a1;

    .custom-modal-content {
        border-radius: var(--modal-border-radius) !important;
        border: none !important;
        overflow: hidden !important;
    }

    .custom-modal-header {
        padding: var(--modal-padding-y) var(--modal-padding-x) !important;
        background-color: #ffffff !important;

        .modal-title {
            font-weight: 600 !important;
            font-size: 18px !important;
        }
    }

    .custom-modal-body {
        padding: 24px 25px !important;

        &:focus,
        &:focus-visible {
            outline: none !important;
        }
    }

    .custom-modal-body-with-bg {
        background-color: rgba($brand-color, 0.03) !important;
    }

    .custom-modal-footer {
        padding: 18px 22px !important;
        background-color: var(--modal-footer-bg) !important;

        .btn {
            font-weight: 500 !important;
            padding: 8px 16px !important;
        }

        .btn-secondary {
            background-color: var(--button-secondary-bg) !important;
            border-color: #e5e5e5 !important;
            color: #666 !important;

            &:hover:not(:disabled):not(.disabled) {
                background-color: var(--button-secondary-hover) !important;
                border-color: #d8d8d8 !important;
            }
        }
    }

    @media (max-width: 600px) {
        .custom-modal-dialog {
            margin: 10px auto !important;
            width: 95% !important;
        }
    }

    body.modal-open {
        overflow: hidden !important;
    }
</style>
